import { render } from "./SnapshotIcon.pug?vue&type=template&id=a80f6c2c&lang=pug"
import script from "./SnapshotIcon.js?vue&type=script&lang=js"
export * from "./SnapshotIcon.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__